import apiClient from './client';
import { ApiResponse, PaginatedResponse, PaginationParams, User } from '@/types';

export const usersApi = {
  getAll: (params?: PaginationParams & { role?: string; isActive?: boolean }) =>
    apiClient.get<PaginatedResponse<User>>('/users', { params }),

  getById: (id: string) =>
    apiClient.get<ApiResponse<User>>(`/users/${id}`),

  create: (data: Partial<User>) =>
    apiClient.post<ApiResponse<User>>('/users', data),

  update: (id: string, data: Partial<User>) =>
    apiClient.put<ApiResponse<User>>(`/users/${id}`, data),

  remove: (id: string) =>
    apiClient.delete<ApiResponse<void>>(`/users/${id}`),
};
